export default __webpack_public_path__ + "static/media/prev-E1A-3.babc65f6.png";